/**
 * Format a Date in local time as yyyy/mm/dd hh:mm:ss AM/PM.
 *
 * Used for rendering `.utc-datetime[data-utc]` spans consistently across pages.
 */
export function formatLocalDatetime(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return "-";
  }

  const pad = (value) => String(value).padStart(2, "0");
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());

  let hours = date.getHours();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${year}/${month}/${day} ${pad(hours)}:${pad(date.getMinutes())}:${pad(
    date.getSeconds(),
  )} ${ampm}`;
}

export function initUtcDatetimes(root) {
  (root || document)
    .querySelectorAll(".utc-datetime[data-utc]")
    .forEach(function (el) {
      if (el.getAttribute("data-kt-initialized") === "1") return;
      el.setAttribute("data-kt-initialized", "1");

      var utcString = el.getAttribute("data-utc");
      if (!utcString) {
        el.textContent = "-";
        return;
      }
      el.textContent = formatLocalDatetime(new Date(utcString));
    });
}
